import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Client } from './client';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs';
import { pluck, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Injectable()
export class VehicleService {
  private createNewVehicleSource = new BehaviorSubject({ data: { id: '' }, service: '' });
  createdNewVehicle = this.createNewVehicleSource.asObservable();
  private editVehicleSource = new BehaviorSubject({ data: { id: '', groups: [] }, service: '' });
  editedVehicle = this.editVehicleSource.asObservable();
  private carDriversSource = new BehaviorSubject([{ callsign: '', id: '' }]);
  carDriversDetail = this.carDriversSource.asObservable();
  private indexDeletedDriverSoirce = new BehaviorSubject<number>(-1);
  indexDletedDriver = this.indexDeletedDriverSoirce.asObservable();
  private addVehicleDriverSource = new BehaviorSubject({ id: '', callsign: 0 });
  addVehicleDriver = this.addVehicleDriverSource.asObservable();
  private carIdSource = new BehaviorSubject<string>('');
  carId = this.carIdSource.asObservable();

  vehicleModelsObjs = [];

  constructor(private http: HttpClient, private client: Client) {}

  emittCarId(id: string) {
    return this.carIdSource.next(id);
  }

  emmittAddVehicleDriver(obj) {
    return this.addVehicleDriverSource.next(obj);
  }

  emittIndexDeletedDriver(index: number) {
    return this.indexDeletedDriverSoirce.next(index);
  }

  emittCarDrivers(arr) {
    return this.carDriversSource.next(arr);
  }

  emittEditVehicle(obj) {
    return this.editVehicleSource.next(obj);
  }

  emittCreateNewVehicle(obj) {
    return this.createNewVehicleSource.next(obj);
  }

  getVehicles(obj) {
    return this.http.get(this.client.getVehiclesUrl(), { params: new HttpParams({ fromObject: obj }) });
  }

  getVehicle(obj) {
    // Get id of driver
    return this.http.get(this.client.getVehicleUrl(obj));
  }

  getColor() {
    return this.http.get(this.client.getColorUrl());
  }

  getCountry() {
    return this.http.get(this.client.getCountryUrl());
  }

  getVehicleBody() {
    return this.http.get(this.client.getVehicleBodyTypesUrl());
  }

  getVehicleBrands() {
    return this.http.get(this.client.getVehicleBrandsUrl());
  }

  getVehicleBrandAndModel(modelId: number): Observable<any> {
    const vehicleModelObj: any = (this.vehicleModelsObjs || []).find(item => item.id === modelId);
    if (vehicleModelObj) {
      return of(vehicleModelObj);
    } else {
      return this.http
        .get<any>(this.client.getVehicleBrandUrl(), { params: { id: `${modelId}` } })
        .pipe(
          pluck('data'),
          tap((data: any) => {
            if (!this.vehicleModelsObjs.some(item => item.id === modelId)) {
              this.vehicleModelsObjs.push(data);
            }
          })
        );
    }
  }

  getVehicleModel(obj) {
    return this.http.get(this.client.getVehicleModelUrl(obj));
  }

  getVehicleCategories() {
    return this.http.get(this.client.getVehicleCategoriesUrl());
  }

  getVehicleClasses() {
    return this.http.get(this.client.getVehicleClassesUrl());
  }

  getVehicleDrivers(obj) {
    return this.http.get(this.client.getVehicleDriversUrl(obj));
  }

  getVehicleGroups(obj) {
    return this.http.get(this.client.getVehicleGroupsUrl(obj));
  }

  updateVehicleGroup(obj) {
    return this.http.put(this.client.updateVehicleGroupUrl(), obj);
  }

  getVehiclesQuantity(obj) {
    return this.http.get(this.client.getVehicleGroupCountUrl(obj));
  }

  moveVehicleGroup(obj) {
    return this.http.post(this.client.moveVehicleGroupUrl(obj.service_id), obj);
  }

  deleteGroup(obj) {
    return this.http.delete(this.client.updateVehicleGroupUrl(), { params: obj });
  }

  createVehicleGroup(obj, service_id) {
    return this.http.post(this.client.createVehicleGroupUrl(service_id), obj);
  }

  deleteVehicle(obj) {
    return this.http.delete(this.client.getVehicleDeleteUrl(obj));
  }

  createVehicle(obj) {
    return this.http.post(this.client.getVehicleCreateUrl(), obj);
  }

  editVehicle(obj) {
    return this.http.post(this.client.VehicleUpdateUrl(), obj);
  }

  addNewBrand(name) {
    return this.http.post('operator/dictionary/admin/vehicle-brands', { name });
  }

  addNewModel(name, brand_id) {
    return this.http.post('operator/dictionary/admin/vehicle-models', { name, brand_id });
  }

  changeCabHiddenMode(cabId: string, isLocked: boolean): Observable<any> {
    return this.http.put('operator/drivers/hidden-mode', { cab_id: cabId, is_locked: isLocked });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/vehicle.service.ts